import React, { useState } from "react";
import {
  Close as CloseIcon,
  Dashboard as DashboardOutlinedIcon,
  AccountCircle as AccountCircleOutlinedIcon,
  Groups as Groups2OutlinedIcon,
   CurrencyRupee as CurrencyRupeeOutlinedIcon,
  Wallet as WalletOutlinedIcon,
  AccountBalance as AccountBalanceWalletOutlinedIcon,
  PriceChange as PriceChangeOutlinedIcon,
  Dvr as DvrOutlinedIcon,
  LocalAtm as LocalAtmOutlinedIcon,
  SendToMobile as SendToMobileOutlinedIcon,
  Description as DescriptionOutlinedIcon,
  ImportExport as ImportExportIcon,
  ArrowDropDownOutlined,
  ArrowDropUpOutlined,
} from "@mui/icons-material";
import KeyIcon from "@mui/icons-material/Key";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useWallet } from "../context/walletContext";
import { formatAmount } from "../utils/formatAmount";
import BrandLogo from "../utils/logoImg";
import { Tooltip } from "@mui/material";
import {
  closeSidebar,
  toggleSidebarCollapsed,
} from "../app/sidebarSlice";
import ConfirmDialog from "./ui/ConfirmDialog";
import { DESIGN_TOKENS } from "../designSystem/tokens";

const ADMIN_PORTAL_URL = "https://admin.ezypayind.com";
const HEADER_H = DESIGN_TOKENS.layout.navbarHeight;

const Sidebar = ({ mobile = false, collapsed: collapsedProp }) => {
  const { collapsed: collapsedState } = useSelector((state) => state.sidebar);
  const collapsed = mobile ? false : collapsedProp ?? collapsedState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [adminConfirmOpen, setAdminConfirmOpen] = useState(false);
  const { walletAmt } = useWallet();
  const userInfo = useSelector((state) => state.auth?.userInfo);
  const aepsStatus = userInfo?.aepsStatus;
  const isAdmin =
    userInfo?.role === "admin" || userInfo?.role === "super_admin";

  const toggleDropdown = (label) => {
    setOpenDropdown(openDropdown === label ? null : label);
  };

  const closeMobile = () => {
    if (mobile) dispatch(closeSidebar());
  };

  const menuItems = [
    {
      icon: <WalletOutlinedIcon fontSize="medium" />,
      label: "Main Wallet",
      amount: `${formatAmount(walletAmt?.main?.balance)}`,
    },
    // {
    //   icon: <WalletOutlinedIcon fontSize="medium" />,
    //   label: "AEPS Wallet",
    //   amount: `${formatAmount(walletAmt?.aeps?.balance)}`,
    // },
    {
      icon: <WalletOutlinedIcon fontSize="medium" />,
      label: "MATM Wallet",
      amount: `${formatAmount(walletAmt?.addMoney?.balance)}`,
    },
    {
      icon: <DashboardOutlinedIcon fontSize="medium" />,
      label: "Dashboard",
      path: "/dashboard",
    },
    {
      icon: <AccountCircleOutlinedIcon fontSize="medium" />,
      label: "My Profile Details",
      path: "/profile",
    },
    {
      icon: <Groups2OutlinedIcon fontSize="medium" />,
      label: "My Team Members",
      path: "/team",
    },
      // {
      //     icon: <CurrencyRupeeOutlinedIcon />,
      //     label: "Team Wallet Load",
      //     path: "/team-wallet",
      //   },
    {
      icon: <DvrOutlinedIcon fontSize="medium" />,
      label: "Registration",
      children: [{ label: "Agent Registration", path: "/register" }],
    },
    // {
    //   icon: <LocalAtmOutlinedIcon fontSize="medium" />,
    //   label: "AEPS Module",
    //   children: [
    //     { label: "AEPS Dashboard", path: `/aeps/dashboard` },
    //     ...(aepsStatus === "ACTIVE"
    //       ? [
    //           { label: "AEPS History", path: `/aeps-history` },
    //           { label: "Balance Enquiry", path: "/aeps/balance-enquiry" },
    //           {
    //             label: "Aadhaar Pay",
    //             path: `/aeps/aadhaar-pay/${userInfo?.userName}`,
    //           },
    //           {
    //             label: "Mini Statement",
    //             path: `/aeps/mini-statement/${userInfo?.userName}`,
    //           },
    //           { label: "Aeps Ledgers", path: `/aeps/aeps-ledgers` },
    //         ]
    //       : []),
    //   ],
    // },
    {
      icon: <PriceChangeOutlinedIcon fontSize="medium" />,
      label: "Money Transfer",
      children: [
        { label: "Money Transfer", path: "/money" },
        { label: "Money Transfer List", path: "/money-list" },
      ],
    },
    // {
    //   icon: <AccountBalanceWalletOutlinedIcon fontSize="medium" />,
    //   label: "MATM Module",
    //   children: [
    //     { label: "Wallet Statement", path: "/wallet-statement" },
    //     { label: "Settlement History", path: "/settlement-history" },
    //   ],
    // },
        {
          icon: <AccountBalanceWalletOutlinedIcon />,
          label: "MATM",
          children: [
            // { label: "Initiate Add Money", path: "/initiate" },
            { label: "PG + Payout", path: "/pg-payout" },
            { label: "PG + Payout Reports", path: "/pg-payout/history" },
            // { label: "Bank Verification", path: "/matm/bank-verification" },
            // { label: "Add Money Reports", path: "/matm-reports" },
            { label: "Wallet Statement", path: "/wallet-statement" },
            { label: "Settlement History", path: "/settlement-history" },
          ],
        },


          // {
          //     icon: <LocalAtmOutlinedIcon />,
          //     label: "Utility Payments",
          //     children: [
          //       { label: "Direct - CC Bill Payment", path: "/credit" },
          //       { label: "BBPS - CC Bill Payment", path: "/bbps-bill" },
          //       { label: "BBPS Fastag Recharge", path: "/bbps-bill" },
          //       { label: "Payment History", path: "/payment" },
          //     ],
          //   },

    {
      icon: <SendToMobileOutlinedIcon fontSize="medium" />,
      label: "Recharge & Bills",
      children: [
        { label: "New Payment", path: "/rec-payment" },
        { label: "Payment History", path: "/rec-history" },
      ],
    },
    {
      icon: <DescriptionOutlinedIcon fontSize="medium" />,
      label: "BBPS Bills Payment",
      children: [
        // { label: "New Payment", path: "/new-payment" },
        { label: "New Payment", path: "/credit" },
        { label: "Payment History", path: "/bbps-pay" },
      ],
    },
    {
      icon: <ImportExportIcon fontSize="medium" />,
      label: "Reports / Export",
      path: "/data-transfer",
    },
    {
      icon: <KeyIcon fontSize="medium" />,
      label: "Change Password",
      path: "/password-changes",
    },
  ];

  const pathMatches = (path) => {
    if (!path) return false;
    const p = location.pathname;
    if (p === path || p.startsWith(`${path}/`)) return true;
    // keep parent open on related drill-down routes
    if (path === "/rec-history" && p.startsWith("/rec-wallet")) return true;
    if (path === "/rec-payment" && p.startsWith("/rec-wallet")) return true;
    return false;
  };

  const renderNavItem = (item, index) => {
    const isActive = item.path && pathMatches(item.path);
    const isDropdown = !!item.children;
    const childActive = item.children?.some((c) => pathMatches(c.path));
    // Stay open when manually opened OR a child route is active (don't collapse on child click)
    const isOpenDropdown =
      !collapsed && (openDropdown === item.label || !!childActive);
    const leafActive = isActive && !isDropdown;
    const navClass = `ds-nav-item ${leafActive ? "is-active" : ""} ${
      childActive || (isOpenDropdown && isDropdown) ? "is-parent-open" : ""
    } ${collapsed ? "is-collapsed" : ""}`;

    const wrapTip = (node, title) =>
      collapsed && !mobile ? (
        <Tooltip key={index} title={title} placement="right">
          <span className="block">{node}</span>
        </Tooltip>
      ) : (
        node
      );

    if (!isDropdown) {
      if (!item.path && item.amount) {
        return wrapTip(
          <li
            key={index}
            className={`${navClass} justify-between cursor-default opacity-90`}
          >
            <span className="flex items-center gap-2.5">
              <span className="ds-nav-icon">{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </span>
            {!collapsed && (
              <span className="text-[12px] font-bold  
               make-text-primary">
                {item.amount}
              </span>
            )}
          </li>,
          `${item.label} ${item.amount || ""}`
        );
      }

      return wrapTip(
        <Link
          key={index}
          to={item.path}
          onClick={closeMobile}
          className={navClass}
        >
          <span className="ds-nav-icon">{item.icon}</span>
          {!collapsed && <span className="flex-1">{item.label}</span>}
        </Link>,
        item.label
      );
    }

    return (
      <div key={index}>
        {wrapTip(
          <button
            type="button"
            onClick={() => {
              if (collapsed) {
                dispatch(toggleSidebarCollapsed());
                setOpenDropdown(item.label);
                return;
              }
              // If a child is active, keep section open (don't allow accidental close)
              if (childActive) {
                setOpenDropdown(item.label);
                return;
              }
              toggleDropdown(item.label);
            }}
            className={`${navClass} w-[calc(100%-16px)]`}
          >
            <span className="ds-nav-icon">{item.icon}</span>
            {!collapsed && (
              <>
                <span className="flex-1 text-left">{item.label}</span>
                {isOpenDropdown ? (
                  <ArrowDropUpOutlined fontSize="small" />
                ) : (
                  <ArrowDropDownOutlined fontSize="small" />
                )}
              </>
            )}
          </button>,
          item.label
        )}
        {!collapsed && isOpenDropdown && (
          <div className="ml-3 pl-2 border-l border-[var(--border-color)] flex flex-col gap-0.5 mb-1">
            {item.children.map((child, i) => {
              const childIsActive = pathMatches(child.path);
              return (
                <Link
                  key={i}
                  to={child.path}
                  onClick={() => {
                    setOpenDropdown(item.label);
                    closeMobile();
                  }}
                  className={`ds-nav-child ${childIsActive ? "is-active" : ""}`}
                >
                  {child.label}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const footerBtnClass = `ds-nav-item ${collapsed ? "is-collapsed" : ""}`;

  return (
    <div className="h-full flex flex-col bg-[var(--surface-color)] text-[var(--text-dark)]">
      {/* Logo bar — same height as navbar so borders align as one line */}
      {/* <div
        className={`flex items-center flex-shrink-0 border-b border-[var(--border-color)] px-3 ${
          collapsed ? "justify-center" : "justify-between"
        }`}
        style={{ height: HEADER_H }}
      >
        {!collapsed && !mobile && <BrandLogo size="md" />}
        {collapsed && !mobile && <BrandLogo size="sm" />}
        {mobile && (
          <>
            <BrandLogo size="md" />
            <button
              className="p-1 rounded-[var(--radius-md)] border border-[var(--border-color)] ml-auto"
              onClick={closeMobile}
              aria-label="Close menu"
            >
              <CloseIcon fontSize="small" />
            </button>
          </>
        )}
      </div> */}
      <div
  className={`flex items-center flex-shrink-0 border-b border-[var(--border-color)] px-6 ${
    collapsed ? "justify-center" : "justify-between"
  }`}
  style={{ height: HEADER_H }}
>
  {!collapsed && !mobile && (
    <div
      onClick={() => navigate("/")}
      className="cursor-pointer flex items-center"
      aria-label="Go to home"
    >
      <BrandLogo size="md" />
    </div>
  )}

  {collapsed && !mobile && (
    <div
      onClick={() => navigate("/")}
      className="cursor-pointer flex items-center"
      aria-label="Go to home"
    >
      <BrandLogo size="sm" />
    </div>
  )}

  {mobile && (
    <>
      <div
        onClick={() => navigate("/")}
        className="cursor-pointer flex items-center"
        aria-label="Go to home"
      >
        <BrandLogo size="md" />
      </div>

      <button
        className="p-1 rounded-[var(--radius-md)] border border-[var(--border-color)] ml-auto"
        onClick={closeMobile}
        aria-label="Close menu"
      >
        <CloseIcon fontSize="small" />
      </button>
    </>
  )}
</div>

      <ul
        className="flex-1 overflow-y-auto no-scrollbar py-2"
        style={{ scrollbarWidth: "none" }}
      >
        {menuItems.map((item, index) => renderNavItem(item, index))}
      </ul>

      {/* Fixed bottom actions */}
      <div className="flex-shrink-0 border-t border-[var(--border-color)] py-2 bg-[var(--surface-color)]">
        {isAdmin && (
          <Tooltip
            title={collapsed ? "Login to Admin" : ""}
            placement="right"
            disableHoverListener={!collapsed}
          >
            <button
              type="button"
              className={`${footerBtnClass} w-[calc(100%-16px)]`}
              onClick={() => setAdminConfirmOpen(true)}
            >
              <span className="text-[var(--text-muted)] flex">
                <AdminPanelSettingsIcon fontSize="medium" />
              </span>
              {!collapsed && <span>Login to Admin</span>}
            </button>
          </Tooltip>
        )}
        <Tooltip
          title={collapsed ? "Logout" : ""}
          placement="right"
          disableHoverListener={!collapsed}
        >
          <button
            type="button"
            className={`${footerBtnClass} w-[calc(100%-16px)] text-[var(--error-color)]`}
            onClick={() => {
              closeMobile();
              navigate("/logout");
            }}
          >
            <span className="flex text-[var(--error-color)]">
              <LogoutIcon fontSize="medium" />
            </span>
            {!collapsed && <span className="text-[var(--error-color)]">Logout</span>}
          </button>
        </Tooltip>
      </div>

      <ConfirmDialog
        open={adminConfirmOpen}
        title="Switch to Admin Panel"
        message="You are about to open the Admin Panel. Continue?"
        confirmLabel="Continue"
        cancelLabel="Cancel"
        confirmColor="primary"
        onCancel={() => setAdminConfirmOpen(false)}
        onConfirm={() => {
          setAdminConfirmOpen(false);
          closeMobile();
          window.open(ADMIN_PORTAL_URL, "_blank", "noopener,noreferrer");
        }}
      />
    </div>
  );
};

export default Sidebar;
